import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { CaseStudy } from "@/components/CaseStudy";
import { CaseStudyGMU } from "@/components/CaseStudyGMU";
import { CaseStudyEmerson } from "@/components/CaseStudyEmerson";
import { CaseStudyGoodwill } from "@/components/CaseStudyGoodwill";
import { CaseStudyShaw } from "@/components/CaseStudyShaw";
import { Principal } from "@/components/Principal";
import { Projects } from "@/components/Projects";
import { Gallery } from "@/components/Gallery";
import { Services } from "@/components/Services";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import Admin from "@/pages/Admin";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => lenis.scrollTo(el, { offset: -60 }), 400);
    }
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#050505] text-paper min-h-screen" data-testid="app-root">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <CaseStudy />
        <CaseStudyGMU />
        <CaseStudyEmerson />
        <CaseStudyGoodwill />
        <CaseStudyShaw />
        <Projects />
        <Gallery />
        <Services />
        <Principal />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
